// app/javascript/controllers/index.js
import { application } from "./application"
import DnsRecordFormController from "./dns_record_form_controller"
import ClipboardController from "./clipboard_controller"

application.register("dns-record-form", DnsRecordFormController)
application.register("clipboard", ClipboardController)
